module.exports = __webpack_public_path__ + "static/media/banner_ludo-half.d9312ab8.png";